import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  ViewChild,
  inject,
  input,
  output,
} from '@angular/core';
import { FormGroupDirective } from '@angular/forms';
import { ActivatedRoute, Params } from '@angular/router';
import { format, isValid, parseISO } from 'date-fns';
import { RangeDatepickerForm } from './range-datepicker.form';

@Component({
  selector: 'qaroni-range-datepicker',
  templateUrl: './range-datepicker.component.html',
  styleUrls: ['./range-datepicker.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class RangeDatepickerComponent
  extends RangeDatepickerForm
  implements OnInit
{
  readonly year = input<string>('');
  readonly clearable = input<boolean>(true);

  readonly queryParamsChange = output<Params>();

  @ViewChild(FormGroupDirective) formDirective!: FormGroupDirective;

  private route = inject(ActivatedRoute);

  ngOnInit(): void {
    this.subs.add(this.route.queryParamMap.subscribe(this.getQueryParamMap));
  }

  get minDate(): Date {
    return new Date(+this.year(), 0, 1);
  }

  get maxDate(): Date {
    return new Date(+this.year(), 11, 31);
  }

  public closeDatepicker(): void {
    const queryParamsEmit: Params = { ...this.route.snapshot.queryParams };
    const dateFrom = this.toDate(this.dateFrom?.value);
    const dateTo = this.toDate(this.dateTo?.value);

    if (isValid(dateFrom) && isValid(dateTo)) {
      queryParamsEmit.dateFrom = format(dateFrom, 'yyyy-MM-dd');
      queryParamsEmit.dateTo = format(dateTo, 'yyyy-MM-dd');
    } else if (!this.clearable()) {
      this.getQueryParamMap(this.route.snapshot.queryParamMap);
      return;
    } else {
      delete queryParamsEmit.dateFrom;
      delete queryParamsEmit.dateTo;
    }

    this.queryParamsChange.emit(queryParamsEmit);
  }

  public onClear(): void {
    this.resetSearchByDates();
    this.formDirective.resetForm();

    const queryParams: Params = { ...this.route.snapshot.queryParams };
    delete queryParams.dateFrom;
    delete queryParams.dateTo;

    this.queryParamsChange.emit(queryParams);
  }

  private toDate(value: Date | string): Date {
    return typeof value === 'string' ? parseISO(value) : value;
  }
}
